module.exports = __webpack_public_path__ + "static/media/B_yellow_moment.37c756e1.png";